import { useEffect, useRef } from 'react';

export default function EodConsole({ log, onClear, title = 'Live Console', subtitle }) {
  const logRef = useRef(null);

  useEffect(() => {
    const el = logRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [log]);

  return (
    <div className="eod-console-card">
      <div className="eod-console-header">
        <div className="eod-console-title">
          <div className="title">{title}</div>
          {subtitle && <div className="subtitle">{subtitle}</div>}
        </div>
        <button type="button" className="eod-btn-clear" onClick={onClear}>Clear</button>
      </div>
      <div className="eod-console-body">
        <div ref={logRef} className="eod-log">{log}</div>
      </div>
    </div>
  );
}